// ════════════════════════════════════════════════════════════
//  ringside.js — THE CROWD, WILLIE'S SCRIPT, AND THEIR DIALS
// ════════════════════════════════════════════════════════════
//  caP'n, 2026-10-16: "it'd be really cool to see the combatants there
//  with a crowd of all of the toonz we have canon from Terror … there's a
//  list of approved species etc to use we used them in the Pierre as
//  placeholders go ahead and put them here too."
//
//  THE POOL is the Pier's (PIERRE_PRIME L48/L92): the 12 card lineages
//  (ieBeingModels.jsx) + the 37 vault species (ieTerrorSpecies.jsx) —
//  49 beings, CARDS ONLY. Never V'ael, Willie or any other NPC in the
//  stands, never Bodies' own cast, never Rush's four extra H bodies.
//  Both kits are vendored byte-identical; nothing here edits a body.
//
//  ⚑ Every line Willie says below is a PLACEHOLDER written by Claude,
//  not canon — caP'n rewrites them. Friend-talk, short (the NPC rule).
// ════════════════════════════════════════════════════════════
import { LINEAGE_IDS } from "../ieBeingModels.jsx";
import { SPECIES_IDS } from "../ieTerrorSpecies.jsx";

// every being allowed in the stands: { kit: "lineage" | "species", id }
export const CROWD_POOL = [
  ...LINEAGE_IDS.map((id) => ({ kit: "lineage", id })),
  ...SPECIES_IDS.map((id) => ({ kit: "species", id })),
];

// ── the dials ────────────────────────────────────────────────
// caP'n, 2026-10-16: "back them up maybe 3 times as far back so they seem smaller,
// then fill the gaps with more seats and beings so its more like a stadium with a
// top deck level but still wanna see the gorgeous unstable world's background"
//
// caP'n, same night: "make it further back so it looks like its floating remember
// this is the unstable world don't be afraid to be creative with it"
//
// THE FLOATING STANDS: every section of every ring is its OWN ISLAND — a broken
// slab of terrace on top, a rock keel tapering into the void underneath (the
// Arena's own spire, upside-down logic), a Khao glow leaking from below — and
// each one bobs on its own slow rhythm, crowd and all. Two rings of islands.
// Each ring: first tread at radius r0 / height y0, then `rows` treads, each dr
// further out and dy higher; `keel` = how deep the rock hangs; `phase` turns the
// ring so its gaps land where we want them. A being sits on every tread.
// They are RAISED INTO THE SKY on purpose: the first pass sat them low and the
// ringside camera never saw a single keel — they read as walls, not islands.
// `lift` = each island's own extra height, seeded between [lo, hi], so a ring is a
// scatter of rocks at different heights with sky between them, never a wall.
// ⚑ MEASURED from the ringside camera (h 3.6, ~11 out, looking across ~65–95;
//   the plate's far edge sits at ~-9°, the frame's top edge at ~+13.6°):
//   · lower ring keels (bottom ≈ -6, deeper on unlifted islands) ≈ -8.5° — at the
//     plate's edge: the undersides, their clouds and the void below are SEEN
//   · (caP'n 2026-10-16: "put both levels down just a bit" → lower -1, top -1.5)
//   · lower ring backs ≈ 5–8°, top ring fronts ≈ 6.5°+, top ring backs ≈ 9.5–12.4°
//   · the black hole sits at ~130° round the ring, ~7° up, and it's huge — so BOTH
//     rings' `phase` puts a gap on it (lower: -5° → a boundary at 130°; top:
//     10° → a boundary at 130°): the hole is FRAMED by the islands.
// Move a ring and you change all of that — re-measure first.
export const STADIUM = [
  { name: "lower", r0: 54, rows: 8, dr: 1.6, dy: 0.8, y0: 3.0,  sections: 8, gapDeg: 12, keel: 9, phase: -5, lift: [0, 4] },
  { name: "top",   r0: 72, rows: 7, dr: 1.6, dy: 0.8, y0: 11.5, sections: 6, gapDeg: 26, keel: 8, phase: 10, lift: [0, 5] },
  // THE CLOSE DECK (caP'n 2026-10-17: "make sure the spectator section is closer and unobstructed"):
  // a small ring of islands near the plate so a Front Row seat is a few strides from the fight, not 55.
  // Appended LAST so the other rings' seeded lifts don't move. Wide gaps: the broadcast camera and
  // Ringside look straight through them. ⚠ re-check Ringside + the fight's broadcast before moving it.
  { name: "close", r0: 27, rows: 3, dr: 1.5, dy: 0.65, y0: 1.2, sections: 4, gapDeg: 70, keel: 4, phase: 45, lift: [0, 1.2] },
];
// ring order from the plate outward (for ↑ ↓ in the Front Row) — by radius, not by list position
export const DECK_ORDER = STADIUM.map((_, i) => i).sort((a, b) => STADIUM[a].r0 - STADIUM[b].r0);
// how the islands float: a slow swell + a slower drift, each island its own phase
export const ISLAND_BOB = { amp: 0.45, speed: 0.22, amp2: 0.25, speed2: 0.09 };
export const DEBRIS = { count: 80, rMin: 22, rMax: 52, clearR: [23, 34],   // clearR: the Close Deck's ring is kept free of loose rock
   yMin: -14, yMax: 12, sizeMin: 0.35, sizeMax: 2.4 };
// ── WHAT HOLDS THE ISLANDS UP ────────────────────────────────
// caP'n 2026-10-16 (on the Lyf tethers): "very awesome partner good idea, let's build
// on it, if you want it to look like its holding it let's just really go for it >:3
// for this one, I want clouds with movement holding them up, no tethers for now"
//   "clouds" — a churning cloud bank under every island, wrapped round its rock (BUILT)
//   "hand"   — 📌 caP'n's idea for another: "make the tethers go under the actual crowd
//              islands and put a 'real' hand holding it underneath like an Aethereal
//              one" — NOT BUILT YET; the switch is here so it slots in per island.
export const HOLD = "clouds";
export const TETHERS = false;              // the plate → island Lyf threads (kept, switched off)
export const CLOUDS = {
  perIsland: 34,                           // puffs under each island
  size: [9, 19],                           // puff size range (world units) — big and overlapping: one bank, not dots
  drift: 1.4,                              // how far a puff wanders round its spot
  speed: [0.04, 0.12],                     // how fast it wanders (rad/s)
  top: "#a898d8", belly: "#2a1f4e", glow: "#7CE7FF",   // lit where it meets the slab, shaded below, a Khao glow in the belly
};
// The Unstable World is pushed out past the stands: every element sits at a
// multiple of this radius (shards from 1.5×, pillars 1.7×, eclipse 2.2×, hole 2.3×),
// so 62 puts the nearest shard at ~93, behind the top ring's back wall (~84).
export const WORLD_BOUNDS = { cx: 0, cz: 0, radius: 62, minH: 0, maxH: 3 };

export const SEAT_GAP = 1.3;            // shoulder to shoulder along a row
export const CROWD_FILL = 0.94;         // share of seats taken (a few empties read as real)
export const CROWD_TIERS = [0.72, 0.2, 0.08];   // share of Beb / Champion / Lord in the seats
export const CROWD_HEIGHT = { beb: 1.7, champion: 2.0, lord: 2.4 };
export const CORNERS = { A: -4.6, B: 4.6 };    // x of each corner's middle (Willie turns to it, the camera leans to it)
// each corner's three, nearest Willie first: a diagonal that recedes outward,
// so the broadcast camera sees all three instead of one hiding another
export const CORNER_SPOTS = [[3.1, 0.5], [4.9, -0.5], [6.7, -1.5]];   // [|x|, z]
export const FINAL_COUNT = 10;                 // the last N seconds are Willie counting down, fireworks up

// ── Willie's script: one beat every BEAT seconds, looping while we wait ──
export const BEAT = 5.2;
// ✎ THE WORDS NOW LIVE IN data/text.json (edit them in The Sun Dial). Same names as before:
export { SCRIPT, FINAL_LINES, finalLine, HANDOFF_LINE, CORNER_NAMES } from "./words.js";

// ── THE CROWD'S LITTLE MOMENTS (three/CrowdProps.jsx) ────────────────
// caP'n, 2026-10-16: "the fans in the stands held up signs with the fighters names or
// sometimes just random stuff, references to other things like V'ael or The Pierre,
// random funny stuff like beach balls, random stuff happening in the stands, but not
// tooo much don't want it going crazy over there with chaos"
// So: a FEW signs (they raise, wave a while, lower, come back as something else) and a
// FEW beach balls that lob across one island and then go away for a good long while.
// Everything is a dial. `on: false` turns the whole thing off.
export const CROWD_PROPS = {
  on: true,
  signs: {
    perIsland: 2,            // 14 islands → 28 signs among ~2,900 fans
    frontRows: 3,            // held only in an island's first N rows, so they're seen, not hidden behind the row ahead
    up: [14, 26],            // seconds a sign stays raised
    down: [6, 16],           // seconds it's lowered before coming back as something new
    size: 3.1,               // board width (world units; a fan is ~2 tall)
    nameShare: 0.42,         // chance a fresh sign is a FIGHTER sign (the rest are random gags)
  },
  balls: {
    count: 3,                // at most this many in the air at once
    radius: 0.55,
    lob: 1.9,                // seconds per bounce
    flight: [9, 14],         // seconds a ball spends crossing its island
    rest: [20, 45],          // seconds it's gone before another one shows up somewhere else
  },
};
// ⚑ the sign gags are Claude's PLACEHOLDERS, not canon, and now live in data/text.json ("signs.gags"): caP'n rewrites them in The Sun Dial.
// "\n" = a line break; long ones split themselves. Keep them kind: it's a crowd, not a roast.
export { SIGN_GAGS } from "./words.js";

// ── THE WAVE (caP'n 2026-10-16: "yess maybe it triggers when you ruin an adversary's being") ──
// A stadium wave: one swell of fans standing up and sitting down, racing round BOTH
// decks at once (the hop is by angle, so every island joins as it passes). Signs rise with it.
// Today it runs by itself every so often. THE TRIGGER SEAM for "a being was ruined":
//   cue.current.waveReq = (cue.current.waveReq || 0) + 1     // → a wave starts now
// The stands only exist in Ringside (before the fight) for now, so nothing calls it yet.
export const WAVE = {
  every: [75, 140],   // seconds between the idle waves (first one comes 75–140 s after the stands fill)
  speed: 1.1,         // radians/second round the ring (a lap ≈ 5.7 s)
  height: 1.1,        // how far the fans pop up
  width: 9,           // bigger = a narrower swell
};

// ── THE CROWD AT THE FIGHT ITSELF (caP'n 2026-10-16: "absolutely need the crowd with all
// their signs and stuff there") — the same floating stadium surrounds the fight arena
// (three/Stands.jsx, shared with Ringside). To fit it the Unstable World is pushed out to
// WORLD_BOUNDS there too, and the fog backs off, exactly as in Ringside. `false` = the old
// compact radius-15 fight sky, no crowd.
export const CROWD_IN_FIGHT = true;
// what the fight does to the crowd: cheer = how loud (0.2 always murmuring → 1 roaring),
// each moment holds the roar for this many seconds; a ruin also starts THE WAVE
export const FIGHT_CHEER = { base: 0.2, ruined: 3.2, transcend: 2.6, ultArt: 1.8, bigClash: 1.6, heavyHit: 0.7, clash: 0.5 };
